import { ProductQuoteV3Dimension } from '@orus.eu/dimensions'
import type { QuoteModelInput, RcpaQuoteV3 } from '@orus.eu/pricing'

export class RcpaQuoteDimension<NAME extends string> extends ProductQuoteV3Dimension<
  NAME,
  1,
  QuoteModelInput,
  RcpaQuoteV3
> {}

export const rcpaQuoteDimension = new RcpaQuoteDimension({
  name: 'rcpaQuote',
  displayKeys: { name: 'dimension_name_rcpa_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
